<template>
  <div class="swa-pagniation-container">
    <UiLabel
      class="body-m label"
      :text="
        $t('products.showMoreProducts', {
          visibleProducts,
          totalProducts,
        })
      "
      color="var(--color-base-grey-50)"
    />
    <UiButton
      v-if="isButtonVisible"
      :text="$t('products.showMoreProductsButton')"
      :type="BtnType.TERTIARY"
      :size="BtnSize.LARGE"
      @click="showMoreProducts"
    />
  </div>
</template>

<script setup lang="ts">
import type { PaginationProps } from '~/types/components/product-listing/pagination/pagination.types'
import UiLabel from '@sephora-asia/ui-label'
import UiButton, { BtnType, BtnSize } from '@sephora-asia/ui-button'

const emit = defineEmits(['showMoreProducts'])
defineProps<PaginationProps>()

const { trackEvent } = useGtmTrack()
const pageMetaStore = usePageMetaStore() // Destructuring breaks top-lvl refs
const route = useRoute()

function showMoreProducts() {
  emit('showMoreProducts')

  const trackingParams = {
    campaign_name: pageMetaStore.campaignName,
    page_path: route.path,
  }
  trackEvent({ event: 'lp_show_more_products_click', params: trackingParams })
}
</script>

<style lang="scss" scoped>
.swa-pagniation-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  align-self: center;

  .label {
    margin-bottom: 8px;
  }
}
</style>
